exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-list[data-v-150254fa]{list-style-type:none;display:flex;flex-direction:column}.file-list li[data-v-150254fa]{display:flex;align-items:center;justify-content:space-between;border-bottom:2px solid #f1f4f6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-150254fa","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/user/received-files-panel.vue
// module id = 64
// module chunks = 0